import { yupResolver } from "@hookform/resolvers/yup";
import {
  Badge,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { SketchPicker } from "react-color";
import ImageUploading from "react-images-uploading";
import DefaultProfileImg from "../../assets/images/defaultProfileImg.jpg";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import Chip from "@mui/material/Chip";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimeField } from "@mui/x-date-pickers";
import { toast } from "react-hot-toast";
import { difficultyLevelEditApi } from "../../store/difficulty/difficultyEdit";
import { difficultyLevelAddApi } from "../../store/difficulty/difficultyAdd";
import { difficultyLevelDetailsApi } from "../../store/difficulty/difficultyDetail";
const schema = yup
  .object({
    title: yup.string().required("please provide a difficulty level name ").trim(),
  })
  .required();

export default function DifficultyLevelEdit() {
  const difficultyLevelDetails = useSelector((state) => state?.difficultyLevelDetails);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const params = useParams();
  const navigate = useNavigate();
  const difficultyLevelAdd = useSelector((state) => state?.difficultyLevelAdd);
  const difficultyLevelEdit = useSelector((state) => state?.difficultyLevelEdit);
  useEffect(() => {
    if (params.id) {
      dispatch(difficultyLevelDetailsApi(params.id));
    }
  }, [dispatch]);

  const handleUpdateForm = async (value) => {
    var newObj;
    if (value.title_hn === '')
      delete value.title_hn
    if (params.id) {
      newObj = { ...value, id: params.id };
      await dispatch(difficultyLevelEditApi(newObj));
      if (!difficultyLevelAdd?.loading) {
        navigate("/difficulty-level-management");
      }
    } else {
      await dispatch(difficultyLevelAddApi(value));
      if (!difficultyLevelEdit?.loading) {
        navigate("/difficulty-level-management");
      }
    }
  };

  useEffect(() => {
    let defalutValues = {};
    if (params.id) {
      defalutValues["title"] = difficultyLevelDetails.result?.title;
      defalutValues["title_hn"] = difficultyLevelDetails.result?.title_hn;
    }
    reset(defalutValues);
  }, [difficultyLevelDetails]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <Typography>Difficulty Level Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />

                  <Stack direction="row" spacing={2}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title
                      </InputLabel>
                      <OutlinedInput
                        {...register("title")}
                        label="title"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title?.message}
                      />
                      <FormHelperText error>
                        {errors?.title?.message}
                      </FormHelperText>
                    </FormControl>

                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title (Hindi)
                      </InputLabel>
                      <OutlinedInput
                        {...register("title_hn")}
                        label="title_hn"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title_hn?.message}
                      />
                      <FormHelperText error>
                        {errors?.title_hn?.message}
                      </FormHelperText>
                    </FormControl>
                  </Stack>
                </Stack>
              </Card>
              <Button
                type="button"
                sx={{ float: "right", mt: 2, ml: 2 }}
                variant="contained"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{ float: "right", mt: 2 }}
                variant="contained"
              >
                {params.id ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Body>
    </>
  );
}
